import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { CdrGlobalContext } from "../../../../context/cdrGlobalContext";
import { SET_PRODUCTO_SELECCIONADO } from "../../../../context/constantes";
import { cdrAPI } from "../../../../utils/funcionesAPI";
import get from "../../../../utils/get";
import { manejadorDeRespuesta } from "../../../../utils/Tools";

const Precio = (props) => {
  const { producto } = props;
  const {
    precioSinIva,
    nochesADescontar,
    porcentajeNocheDescuento,
    cantidadNoches,
    habitaciones,
    precioTotalCDRSinIva
  } = producto;
  /*
    promoDescuentoActual,
    promoDescuentoCercano,
    promoPorDias,
  */
  const [, dispatch] = useContext(CdrGlobalContext);
  const [message, setMessage] = useState('');

  const validateSeleccionDeCama = (producto) => {
    let rto = true;
    producto.habitaciones.map(habitacion => {
      const combinacionesDeCamas = get(habitacion, 'tipoDeHabitacion.combinaciones', []);
      if (combinacionesDeCamas.length > 0 && !habitacion.idCombinacionCama) rto = false;
    })
    return rto;
  }

  const validateRegimenSeleccionado = (producto) => {
    let rto = true;
    producto.habitaciones.map(habitacion => {
      if (producto.regimenes.length > 0 && !habitacion.regimenSeleccionado) rto = false;
    })
    return rto;
  }

  const handleComprarClick = (e) => {
    e.preventDefault();
    if (!validateSeleccionDeCama(producto)) {
      setMessage('Debe seleccionar combinación de camas para todas las habitaciones');
      return;
    }

    if (!validateRegimenSeleccionado(producto)) {
      setMessage('Debe seleccionar un regimen para todas las habitaciones');
      return;
    }

    const data = JSON.stringify({
      peticion: "calcularTotalesDelProducto",
      productoSeleccionado: producto
    });
    cdrAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        dispatch({ type: SET_PRODUCTO_SELECCIONADO, payload: { 
          producto, respuesta: respuesta.data }});
        props.history.push("/hoteles/proceso-compra/login/");
      } else {
        toast.error(respuesta.mensaje, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
    
    
  };

  if (precioSinIva === 0) {
    return (
      <div className="price col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
        <h5 className="estiloSinPrecio">
          No hay disponibilidad vigente en estas fechas. Pruebe en otro
          rango.
        </h5>
      </div>
    );
  }

  return (
    <div className="price priceCdr col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
      <h6>Alojamiento por Noche por habitacion</h6>
      <h3>$ {precioTotalCDRSinIva}</h3>
      <h6>+ Tasas e Impuestos</h6>
      {porcentajeNocheDescuento > 0 && <p style={{color: '#feca00', fontSize: '0.9rem', margin: '0', fontWeight: '600'}} >Aprovecha el descuendo de {porcentajeNocheDescuento} %</p>}
      {nochesADescontar > 0 && <p style={{color: '#feca00', fontSize: '0.9rem', margin: '0', fontWeight: '600'}}>Aprovecha la promoción de {nochesADescontar} día free</p>}
      <button onClick={handleComprarClick}>comprar</button>
      <h6>Pag&aacute; en cuotas</h6>

      <h6 style={{color: 'red'}}>{message}</h6>
    </div>
  );
};

export default withRouter(Precio);

/*
if ($promoDescuentoActual != 0) {
      $publiPromocionDescuentoActual = round(100-($promoDescuentoActual['porcentaje'])*100) . "% OFF";
  } else {
      if ($promoDescuentoCercano != 0) {
          $promoDescuentoActual = round($promoDescuentoCercano['porcentaje']) . "% de Descuento a partir del " . date('d/m/Y', strtotime($promoDescuentoCercano['fecha']));
      }
  }

if($nochesADescontar == 0){
    $publiPromocionTarifa = "Las " .$cantidadNoches.' Noches $' .round($precioAlojamientoPorNC,2). " ";
  }else{
    $publiPromocionTarifa = "Las " .$cantidadNoches.' Noches $' . round($precioAlojamientoPorNC * $nochesADescontar,2). " ";
  }

  if ($promoDias) {
    $acumula = 0;
    foreach ($promoDias as $value) {
        //ALOJÁNDOSE TRES NOCHES LA ULTIMA ES INVITACIÓN.    
        $publiPromocion = $value['nochesNecesarias'] . "  Noches " . round(100-($value['nochesFree'])*100,2) . " % Free ";
        $acumula++;
    }
} 

  if ($promoDiasCercanas != 0) {
      $publiPromocion = "Aprovecha Promocion " . $promoDiasCercanas['nochesFree'] . " noches free cada " . $promoDiasCercanas['nochesNesarias'] . " a partir del " . date('d/m/Y', strtotime($promoDiasCercanas['fecha']));
  }


*/



// WEBPACK FOOTER //
// ./src/components/Hoteles/ResultadosCdr/ProductoCuadro/Precio.js